/* eslint-disable no-restricted-syntax */

const getParamIgnoreCase = (params: URLSearchParams, key: string) => {
  const lowerKey = key.toLowerCase();
  for (const [k, v] of Array.from(params.entries())) {
    if (k.toLowerCase() === lowerKey) return v;
  }
  return null;
};

const UrlService = {
  getParamIgnoreCase
};

export default UrlService;
